/**
 * Quién puede modificar un folio y hasta cuándo (mismo criterio que el API,
 * use_cases/interventions/edit_rules.py — deben coincidir):
 *
 *  · Administrador Epione y Coordinador: cualquier folio, sin límite.
 *  · Técnico: solo sus folios y hasta que termina el TURNO en que acabó la Cx.
 *
 * Turnos: Matutino 07–15 · Vespertino 15–22 · Nocturno 22–07 (día siguiente).
 */
const SHIFTS: [number, number][] = [[7, 15], [15, 22], [22, 31]];

const norm = (v: any) => String(v ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toUpperCase();

/** Fin del turno en que terminó la cirugía (hora local) o null. */
export function folioEditDeadline(record: any): Date | null {
  const raw = String(record?.interventionDatetime ?? '').trim();
  const finish = String(record?.finishHour ?? '').trim();
  if (!raw || !finish) return null;
  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const [hh, mm] = finish.split(':').map(n => parseInt(n, 10));
  if (!m || isNaN(hh) || isNaN(mm)) return null;
  const day = new Date(+m[1], +m[2] - 1, +m[3], 0, 0, 0);
  if (hh < 7) return new Date(day.getTime() + 7 * 3600_000);
  const minutes = hh * 60 + mm;
  for (const [s, e] of SHIFTS) {
    if (minutes >= s * 60 && minutes < e * 60) return new Date(day.getTime() + e * 3600_000);
  }
  return null;
}

/**
 * ¿Puede subir el vale firmado? Folio en Pendiente y, si es técnico, que sea
 * suyo. No aplica el plazo del turno: el vale firmado suele llegar después.
 * Al subirlo el folio pasa a Firmado (POST /interventions/sign).
 */
export function canSignFolio(record: any, userId: string | null, roleNames: string[] | string | null): boolean {
  if (String(record?.status ?? '') !== 'Pendiente') return false;
  const roles = (Array.isArray(roleNames) ? roleNames : [roleNames]).map(norm).filter(Boolean);
  if (!roles.some(r => r.includes('TECNICO')) || roles.some(r => r === 'ADMINISTRADOR EPIONE' || r.includes('COORDINADOR'))) return true;
  const owners = [record?.technician, record?.createdBy].map(x => String(x ?? ''));
  return !!userId && owners.includes(String(userId));
}

/** ¿El usuario (id + nombres de rol) puede modificar este folio ahora? */
export function canEditFolio(record: any, userId: string | null, roleNames: string[] | string | null): boolean {
  const roles = (Array.isArray(roleNames) ? roleNames : [roleNames]).map(norm).filter(Boolean);
  if (!roles.length) return true;                                  // sin rol conocido: lo decide el API
  if (roles.some(r => r === 'ADMINISTRADOR EPIONE' || r.includes('COORDINADOR'))) return true;
  if (!roles.some(r => r.includes('TECNICO'))) return true;
  const owners = [record?.technician, record?.createdBy].map(x => String(x ?? ''));
  if (!userId || !owners.includes(String(userId))) return false;
  const deadline = folioEditDeadline(record);
  return !deadline || new Date() <= deadline;
}
